import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { bindActionCreators } from "redux";
import { getUserInfo } from "../../../actions/user"
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { getWebSessionId } from '../../../actions/user';
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";
class Login extends Component {

    constructor() {
        super()
        this.state = {
            mobile_no: "",
            cons_password: "",
            cons_first_name: "",
            cons_last_name: "",
            cons_email_id: "",
            connection_id: "",
            authType: "L",
        }
        this.loginValidator = new SimpleReactValidator();
        this.validator = new SimpleReactValidator({
            messages: {
                password: 'Please provide Password for your account.',
                firstName: 'Please provide First Name.',
                phone: 'Please provide 10 digit Mobile Phone No.',
                email: "Please provide valid Email ID.",
            }
        });
    }

    componentDidMount() {
        if (this.props.isAuth) {
            toast.success("You are already logged in.");
            this.props.history.push(`/`)
            // this.props.history.goBack()
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.isAuth !== nextProps) {
            if(nextProps.isAuth){
                if (this.setState.auth_type === 'R'){
                    toast.success("Your account registration Successful.");
                }
                else {
                    toast.success("You are logged in.");
                }
                if( this.props.location.state && this.props.location.state.from === "reset"){
                    this.props.history.push('/')
                }
                else{
                    this.props.history.goBack()
                }
            }
        }
    }

    handleChange(event) {
        
        this.setState({ [event.target.id]: event.target.value });

    }

    handleRegistration() {
        this.props.history.push(`/register`)
    }

    handleForgotPassword() {
        this.props.history.push(`/reset-password`)
    }

    //handle submit for login form
    handleLogin = (event) => {
        event.preventDefault();
        this.setState({
            authType: 'L'
        })
        if (this.loginValidator.allValid()) {
            const { connection_id } = this.props
            this.props.getUserInfo({ ...this.state, auth_type: "L", connection_id })
            this.props.getWebSessionId(connection_id);
        } else {
            this.loginValidator.showMessages();
            this.forceUpdate();
        }
    }

    //handle submit for register form
    handleRegister = (event) => {
        event.preventDefault();
        this.setState({
            authType: 'R'
        })
        if (this.validator.allValid()) {
            const { connection_id } = this.props
            this.props.getUserInfo({ ...this.state, auth_type: "R", connection_id })
            this.props.getWebSessionId(connection_id);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        // let signUpStyle = {
        //     fontSize: 12,
        //     marginTop: 7,
        //     cursor: "pointer",
        //     textTransform: "capitalize"
        // }

        let forgotPswdStyle = {
            marginTop: 10,
            fontSize: 12,
            cursor: "pointer",
            textTransform: "capitalize",
            flexGrow: 9
        }

        // let registerNewStyle = {
        //     marginTop: 10,
        //     fontSize: 12,
        //     cursor: "pointer",
        //     textTransform: "capitalize",
        //     flexGrow: 1,
        //     textAlign: "right"
        // }

        return (
            <div>
                <Helmet>
                    <title>{this.props.customer_name}  | login/Register </title>
                    <meta name="description" content=" store" />
                </Helmet>
                {/*Login section*/}
                <section className="tab-product m-0">
                    <div className="container" style={{ marginTop: 40, marginBottom: 40 }}>
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6">
                                <Tabs className="tab-content nav-material">
                                    <TabList className="nav nav-tabs nav-material">
                                        <Tab className="nav-item" style={{ width: "50%" }}>
                                            <span className="nav-link">
                                                <i className="icofont icofont-contacts"></i>LOGIN</span>
                                            <div className="material-border" ></div>
                                        </Tab>
                                        <Tab className="nav-item" style={{ width: "50%" }}>
                                            <span className="nav-link">
                                                <i className="icofont icofont-contacts"></i>REGISTER</span>
                                            <div className="material-border" ></div>
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form className="theme-form mt-4">
                                            <div className="form-row">
                                                <div className="col-md-12" style={{ paddingBottom: 30, paddingTop: 20 }}>
                                                    <input type="text" className="form-control" id="mobile_no"
                                                        placeholder="Enter your mobile number*" value={this.state.mobile_no} onChange={(e) => this.handleChange(e)} />
                                                    {this.loginValidator.message('mobile', this.state.mobile_no, 'required|phone|max:10')}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <input type="password" className="form-control" id="cons_password"
                                                        placeholder="Enter your password*" value={this.state.cons_password} onChange={(e) => this.handleChange(e)} />
                                                    {this.loginValidator.message('password', this.state.cons_password, 'required|min:8')}
                                                </div>

                                                <div className="col-md-12" style={{ paddingBottom: 20 }}>
                                                    <button type="button" onClick={(e) => this.handleLogin(e)} className="btn btn-solid" style={{ width: "100%" }}>Enter</button>
                                                </div>
                                                <div className="col-md-12">
                                                    <div style={{ display: "flex" }}>
                                                        <span style={forgotPswdStyle} onClick={() => this.handleForgotPassword()}>Forgot your password?</span>
                                                        {/* <span style={registerNewStyle} onClick={() => this.handleRegistration()}>Don't have an account? Register</span> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                    <TabPanel>
                                        <form className="theme-form mt-4">
                                            <div className="form-row">
                                                <div className="col-md-12" style={{ textAlign: "center", paddingBottom: 30, paddingTop: 20 }}>
                                                    <span>Create your account and be among the first to find out about our promotions and new lookbooks.</span>
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 10 }}>
                                                    <span>How would you like us to address you?*</span>
                                                </div>
                                                <div className="col-md-12">
                                                    <input type="text" className="form-control" id="cons_first_name"
                                                        placeholder="Name*" value={this.state.cons_first_name} onChange={(e) => this.handleChange(e)} />
                                                    {this.validator.message('first name', this.state.cons_first_name, 'required|alpha_space',  {messages: "firstName"})}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <input type="text" className="form-control" id="cons_last_name"
                                                        placeholder="Surname" value={this.state.cons_last_name} onChange={(e) => this.handleChange(e)} />
                                                    {this.validator.message('last name', this.state.cons_last_name, 'alpha_space')}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 10 }}>
                                                    <span>Enter an e-mail & password to access your account wherever and whenever you like.*</span>
                                                </div>
                                                <div className="col-md-12">
                                                    <input type="text" className="form-control" id="cons_email_id"
                                                        placeholder="Email" value={this.state.cons_email_id} onChange={(e) => this.handleChange(e)} />
                                                    {this.validator.message('email', this.state.cons_email_id, 'required|email',  {messages: "email"})}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <input type="password" className="form-control" id="cons_password"
                                                        placeholder="Enter your password" value={this.state.cons_password} onChange={(e) => this.handleChange(e)} />
                                                        {this.validator.message('password', this.state.cons_password, 'required|min:8',  {messages: "password"})}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 10 }}>
                                                    <span>Add your mobile phone number to track your orders.*</span>
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 30 }}>
                                                    <input type="text" className="form-control" id="mobile_no"
                                                        placeholder="Mobile No" value={this.state.mobile_no} onChange={(e) => this.handleChange(e)} />
                                                    {this.validator.message('phone', this.state.mobile_no, 'required|phone|max:10',  {messages: "phone"})}
                                                </div>
                                                <div className="col-md-12" style={{ paddingBottom: 20 }}>
                                                    <button type="button" onClick={(e) => this.handleRegister(e)} className="btn btn-solid" style={{ width: "100%" }}>Create Account</button>
                                                </div>
                                                <div className="col-md-12" style={{ textAlign: "center", paddingBottom: 10 }}>
                                                    <span>By clicking on ‘Create account’, you accept our Confidentiality Policy.</span>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    error: state.user.error,
    connection_id: state.tenant.connection_id,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getUserInfo, getWebSessionId },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Login));